<div
  class="rule-card"
  [ngClass]="{
    error: rule.lastRun?.status === STATUS.ERROR && rule.status === STATUS.PAUSED
  }"
>
  <div class="rule-card__change">
    <div>
      <img [src]="'/assets/icons/crypto/' + rule.fromTicker.toLowerCase() + '.svg'" alt="coin" />
      <img
        class="rule-card__change-position"
        [src]="'/assets/icons/crypto/' + rule.toTicker.toLowerCase() + '.svg'"
        alt="Coin Destination"
        [ngClass]="{
          ars: rule.toTicker === 'ARS',
          usd: rule.toTicker === 'USD'
        }"
      />
    </div>
    <p>{{ (rule.fromTicker | arsUsdLabel) + ' a ' + (rule.toTicker | arsUsdLabel) }}</p>
  </div>
  <div class="rule-card__amount">
    <p>{{ (rule.amount | number : '0.1-8') + ' ' + (rule.fromTicker | arsUsdLabel) }}</p>
  </div>
  <div class="rule-card__frequency">
    <p>{{ rule.frequency | frequencyTransform }}</p>
    <div
      class="rule-card__frequency-img"
      *ngIf="isMobile"
      [ngClass]="{
        active: openCollapseMobile
      }"
    >
      <img
        (click)="openCollapseMobile = !openCollapseMobile"
        src="/assets/icons/dca/arrow-down-collapse.svg"
        alt="Collapse"
      />
    </div>
  </div>
  <div class="rule-card__next" *ngIf="!isMobile">
    <p>
      {{
        next.nextNumberDays < 0 && rule.status === STATUS.ACTIVE
          ? '-'
          : next.nextNumberDays < 0 && rule.status === STATUS.PAUSED
          ? 'Activar para visualizar'
          : next.nextNumberDays === 0
          ? (next.equalDay ? 'Hoy' : 'Mañana') + ' a las ' + next.nextHours + ':00hs'
          : 'En ' + next.nextNumberDays + ' días a las ' + next.nextHours + ':00hs'
      }}
    </p>
  </div>
  <div class="rule-card__state" *ngIf="!isMobile">
    <div class="rule-card__state-container">
      <div class="rule-card__state__box" (click)="!loadingChangeState && changeState()">
        <div>
          <div class="rule-card__state__box-play">
            <p *ngIf="rule.status === STATUS.ACTIVE; else play">Activo</p>
            <ng-template #play><img src="/assets/icons/dca/play.svg" alt="Play" /></ng-template>
          </div>
          <div class="rule-card__state__box-pause">
            <p *ngIf="rule.status === STATUS.PAUSED; else paused">Pausado</p>
            <ng-template #paused><img src="/assets/icons/dca/pause.svg" alt="Pause" /></ng-template>
          </div>
        </div>
        <div class="container-loading" *ngIf="loadingChangeState">
          <div class="loading">
            <div class="circle-loader"></div>
          </div>
        </div>
      </div>
      <div
        class="rule-card__state-arrow"
        (click)="getStats()"
        [ngClass]="{
          active: openCollapse
        }"
      >
        <img src="/assets/icons/dca/arrow-down-collapse.svg" alt="Collapse" />
      </div>
    </div>
  </div>
  <div
    class="rule-card__error"
    *ngIf="rule.lastRun?.status === STATUS.ERROR && rule.status === STATUS.PAUSED && !isMobile"
    matTooltip="Ocurrió un error, reitenta nuevamente activando la regla o comunicate con nuestro soporte."
    matTooltipPosition="above"
  >
    <img src="/assets/icons/dca/info-error.svg" alt="error" />
  </div>
</div>
<div class="rule-card__collapse" *ngIf="openCollapse">
  <div class="rule-card__collapse-price" *ngIf="ruleStats | async as ruleStats">
    <div>
      <p class="rule-card__collapse-title">Ahorro</p>
      <p class="rule-card__collapse-description">
        {{
          ruleStats?.ruleStats.totalAmount !== 0
            ? cryptoService.isStableCoin(rule.toTicker)
              ? (ruleStats?.ruleStats.totalAmount | number : '0.1-2') +
                ' ' +
                rule.toTicker +
                ' acumulados'
              : (ruleStats?.ruleStats.totalAmount | number : '0.1-8') +
                ' ' +
                rule.toTicker +
                ' acumulados'
            : '-'
        }}
      </p>
    </div>
    <div>
      <p class="rule-card__collapse-title">Precio promedio de compra</p>
      <p class="rule-card__collapse-description">
        {{
          ruleStats?.ruleStats.avgPrice !== 0
            ? (ruleStats?.ruleStats.avgPrice | number : '0.1-2') +
              ' ' +
              (checkIsStable ? rule.fromTicker : rule.toTicker)
            : '-'
        }}
      </p>
    </div>
  </div>
  <div class="rule-card__collapse-resume" *ngIf="ruleStats | async as ruleStats">
    <div>
      <p class="rule-card__collapse-title">Resumen</p>
      <p class="rule-card__collapse-description">
        {{
          ruleStats?.ruleStats.orderCount >= 2
            ? '¡Compraste ' +
              rule.toTicker +
              ' un ' +
              Math.abs(ruleStats?.ruleStats.dcaPriceVsActualPrice) +
              (ruleStats?.ruleStats.dcaPriceVsActualPrice > 0
                ? '% más barato que el precio actual!'
                : '% más caro que el precio actual!')
            : 'A partir de la segunda compra te brindaremos más información.'
        }}
      </p>
    </div>
    <div>
      <img (click)="deleteRule()" src="/assets/icons/dca/trash.svg" alt="Trash" />
    </div>
  </div>
</div>
<div class="rule-card__collapse-mobile" *ngIf="openCollapseMobile">
  <div class="rule-card__collapse-mobile__contain">
    <div class="rule-card__collapse-mobile__header">
      <p [class.active]="tabMobile === 'Detail'" (click)="changeTab('Detail')">Detalle</p>
      <p [class.active]="tabMobile === 'Stats'" (click)="changeTab('Stats')">Estadísticas</p>
    </div>
    <ng-container *ngIf="tabMobile === 'Detail'; else showStats">
      <div class="rule-card__collapse-mobile__next">
        <p class="rule-card__collapse-mobile-title">Próxima</p>
        <p class="rule-card__collapse-mobile-date">
          {{
            next.nextNumberDays < 0 && rule.status === STATUS.ACTIVE
              ? '-'
              : next.nextNumberDays < 0 && rule.status === STATUS.PAUSED
              ? 'Activar para visualizar'
              : next.nextNumberDays === 0
              ? (next.equalDay ? 'Hoy' : 'Mañana') + ' a las ' + next.nextHours + ':00hs'
              : 'En ' + next.nextNumberDays + ' días a las ' + next.nextHours + ':00hs'
          }}
        </p>
      </div>
      <div class="rule-card__collapse-mobile__state">
        <p class="rule-card__collapse-mobile-title">Estado</p>
        <div>
          <div class="container-loading" *ngIf="loadingChangeState">
            <div class="loading">
              <div class="circle-loader"></div>
            </div>
          </div>
          <div class="rule-card__collapse-mobile__state__box">
            <div class="rule-card__collapse-mobile__state__box-play">
              <p *ngIf="rule.status === STATUS.ACTIVE; else play">Activo</p>
              <ng-template #play
                ><img
                  (click)="!loadingChangeState ? changeState() : ''"
                  src="/assets/icons/dca/play.svg"
                  alt="Play"
              /></ng-template>
            </div>
            <div class="rule-card__collapse-mobile__state__box-pause">
              <p *ngIf="rule.status === STATUS.PAUSED; else paused">Pausado</p>
              <ng-template #paused
                ><img
                  (click)="!loadingChangeState ? changeState() : ''"
                  src="/assets/icons/dca/pause.svg"
                  alt="Pause"
              /></ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="rule-card__collapse-mobile__btn-delete">
        <button (click)="deleteRule()">
          Eliminar <img src="/assets/icons/dca/trash-white.svg" alt="Trash" />
        </button>
      </div>
    </ng-container>
    <ng-template #showStats>
      <div class="rule-card__collapse-mobile__stats" *ngIf="ruleStats | async as ruleStats">
        <div>
          <p class="rule-card__collapse-mobile__stats-title">Ahorro</p>
          <p class="rule-card__collapse-mobile__stats-description">
            {{
              ruleStats?.ruleStats.totalAmount !== 0
                ? cryptoService.isStableCoin(rule.toTicker)
                  ? (ruleStats?.ruleStats.totalAmount | number : '0.1-2') +
                    ' ' +
                    rule.toTicker +
                    ' acumulados'
                  : (ruleStats?.ruleStats.totalAmount | number : '0.1-8') +
                    ' ' +
                    rule.toTicker +
                    ' acumulados'
                : '-'
            }}
          </p>
        </div>
        <div>
          <p class="rule-card__collapse-mobile__stats-title">Precio promedio de compra</p>
          <p class="rule-card__collapse-mobile__stats-description">
            {{
              ruleStats?.ruleStats.avgPrice !== 0
                ? (ruleStats?.ruleStats.avgPrice | number : '0.1-2') +
                  ' ' +
                  (checkIsStable ? rule.fromTicker : rule.toTicker)
                : '-'
            }}
          </p>
        </div>
        <div>
          <p class="rule-card__collapse-mobile__stats-title">Resumen</p>
          <p class="rule-card__collapse-mobile__stats-description">
            {{
              ruleStats?.ruleStats.orderCount >= 2
                ? '¡Compraste ' +
                  rule.toTicker +
                  ' un ' +
                  Math.abs(ruleStats?.ruleStats.dcaPriceVsActualPrice) +
                  (ruleStats?.ruleStats.dcaPriceVsActualPrice > 0
                    ? '% más barato que el precio actual!'
                    : '% más caro que el precio actual!')
                : 'A partir de la segunda compra, te brindamos más información.'
            }}
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
